module.exports = __webpack_public_path__ + "images/emoji/deciduous_tree.ea6e1fd916e6a7c4558d.png";